export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

const toLogin = () => {
  location.href = '/giris?next=' + encodeURIComponent(location.pathname);
};

export async function api<T = unknown>(path: string, opts: { method?: string; body?: unknown } = {}): Promise<T> {
  const method = opts.method ?? 'GET';
  const hasBody = method !== 'GET';
  const res = await fetch(path, {
    method,
    headers: hasBody ? { 'Content-Type': 'application/json' } : {},
    body: hasBody ? JSON.stringify(opts.body ?? {}) : undefined,
  });
  if (res.status === 401 && !path.startsWith('/api/login')) {
    toLogin();
    throw new ApiError(401, 'Oturum kapandı, yeniden giriş yapın');
  }
  const data = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) throw new ApiError(res.status, data.error ?? `İstek başarısız (${res.status})`);
  return data;
}

export async function logout() {
  if (!confirm('Çıkış yapılsın mı? Tekrar girmek için şifre gerekecek.')) return;
  await fetch('/api/logout', { method: 'POST' });
  location.href = '/giris';
}

export { toLogin };
